import { render, staticRenderFns } from "./CommunityGroupThumbnail.vue?vue&type=template&id=0396df2c&scoped=true&"
import script from "./CommunityGroupThumbnail.vue?vue&type=script&lang=ts&"
export * from "./CommunityGroupThumbnail.vue?vue&type=script&lang=ts&"
import style0 from "./CommunityGroupThumbnail.vue?vue&type=style&index=0&id=0396df2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0396df2c",
  null
  
)

export default component.exports